import { render, staticRenderFns } from "./SendMessageRepToggle.vue?vue&type=template&id=6642d642&"
import script from "./SendMessageRepToggle.vue?vue&type=script&lang=js&"
export * from "./SendMessageRepToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports